<!-- Localized -->
<template>
  <div class="p-8 rounded-lg bg-white">
    <div
      class="flex items-center justify-center flex-1 bg-card-bg rounded-md gap-2"
      v-if="loading"
    >
      <loader class="my-5" :size="8" />
    </div>
    <div class="flex flex-col gap-4" v-else>
      <p class="font-bold text-2xl pb-4 border-b border-gray-400"> {{ fieldLabel }} </p>
      <div class="p-4 rounded-lg bg-gray-100" v-html="fieldBody" />
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import loader from "@shared/loader";

export default {
  name: 'new-user-consent',

  components: {
    loader,
  },

  data() {
    return {
      fieldLabel: "",
      fieldBody: "",
      loading: false,
    }
  },

  async mounted() {
    await this.fetchConsentConfig();
  },

  beforeDestroy() {
    this.resetParams();
  },

  computed: {
    orgId() {
      return localStorage.getItem('org_id');
    },

    orgType() {
      return localStorage.getItem('org_type');
    }
  },

  methods: {
    async fetchConsentConfig() {
      this.loading = true;

      try {
        const { data } = await axios.get(`global-auth/new-user-consent-config`, {
          params: {
            org_type: this.orgType,
            org_id: this.orgId,
          }
        });

        if (data) {
          this.fieldLabel = data.field_config?.label ?? "";
          this.fieldBody = data.field_config?.placeholder ?? "";
        }
      } catch (error) {
        console.error('Error fetching tenant field details:', error)
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
